export default __webpack_public_path__ + "static/media/bannerdemo_image1.3059b1be.jpeg";